module.exports = __webpack_public_path__ + "img/btn_menu_xg_c.6831dc34.png";